module.exports = __webpack_public_path__ + "static/media/arrowDown.3cac1cdc.svg";